import React, { useState, useEffect, useContext, useCallback, useRef, useMemo } from "react";
import { Col, Row, Button, Form, Modal, Container } from "react-bootstrap";
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';
import { getCDNImage, serviceTypeIcon } from '../../globals';
import { HotelContext } from "../../context/hotel";
import { useParams } from 'react-router';
import { T, TF } from "react-translator-component";
import Screen from '../../components/Screen';
import { useLanguage } from "../../hooks/useLanguage";
import usePerson  from "../../hooks/usePerson";
import { usePerson as usePersonContext } from "../../context/person";
import { el } from "date-fns/locale";
import { formatDateFromLanguage, formatDayMonth, i18nValue, qtyText } from "../../functions";
import '../../scss/_public_dashboard.scss';
import PublicPersonPanel from '../../components/PublicPersonPanel';
import { isHotelCGBeach } from "../../components/CheckIn/hotelConditions";

const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { language: languageApp, setLanguage } = useLanguage()
  const { data: hotel, getUrlPath } = useContext(HotelContext);
  const { data: person, setData: setPerson, logoutPerson } = usePersonContext();

  const [reservationsData, setReservationsData] = useState(null);
  const [loading, setLoading] = useState(true);

  const { getReservations } = usePerson();

  const language = useMemo(() => {

    console.log('currentLanguage - call');
    let curr = "en-US";
    console.log('0406 person', person);
    if (person?.language) {
      curr = person?.language ?? "en-US";
    } else {
      if (languageApp) {
        curr = languageApp ?? "en-US";
      }
    }

    console.log('currentLanguage', curr);
    return curr;

  }, [languageApp, person])

  const Slider = ({ height, images }) => {
    const showControls = (images?.length || 0) > 1;
    return (
      <Carousel style={{ height: height, backgroundColor: '#EEE' }} indicators={false} controls={showControls}>
        {images && images.map((img, idx) => (
          <Carousel.Item key={`dashboard-slider-item-${idx}`}>
            <img className="d-block w-100"
              src={getCDNImage(img)}
              style={{ objectFit: 'cover' }}
            />
          </Carousel.Item>
        ))}
      </Carousel>
    )
  }


  useEffect(async () => {
    // Solo cargar reservaciones si hay datos en el context
    if (person?.fullname) {
      setLoading(true);
      const res = await getReservations(person?.id);
      console.log('res getReservations', res);
      if (res) {
        console.log('0406 - getReservations', res);
        setReservationsData(res?.BookableReservations ?? []);
      }
      setLoading(false);
    }

  }, [person?.id, person?.fullname]);

  const getStatusText = (requestItem) => {
    let _status = requestItem?.BookableReservation?.status || requestItem?.status;
    
    if (!_status) {
      _status = "validating";
    }
    if (requestItem?.status == 'canceled') {
      _status = "canceled";
    }
    if (requestItem?.BookableReservation?.confirmed?.status) {
      _status = "accepted";
    }
    if (requestItem?.BookableReservation?.confirmed?.status == true) {
      _status = "confirmed";
    }
    
    return _status;
  };

  const handleLogout = () => {
    // Destruir el token del person
    const hotelCode = hotel?.code;
    if (hotelCode) {
     logoutPerson();
    }
    // Redirigir a la página pública
    navigate(`/${hotelCode}/`);
  }



  return (
    <Screen
      section={`public_home`}
      title={String(T("general.public")).toUpperCase()}
      showBackButton={false}
      hideHeader={true}
      headerTranslucid={true}
    >
      <div className="public-dashboard">

        {/* Hero Section - Using PublicPersonPanel Component */}
        <PublicPersonPanel
          hotel={hotel}
          person={person}
          getUrlPath={getUrlPath}
        />
        
        

        {!person?.fullname && (
          <Container className="px-3 mt-4">
            <Row>
              <Col lg={12} md={12} className="text-center">
                <div className="empty-state-message">{T("public.dashboard.not-found")}</div>
              </Col>
            </Row>
          </Container>
        )}

        {person?.fullname && (
          <>
            {/* Reservations Section */}
            {loading && (
              <div className="dashboard-reservations-section">
                <div className="loading d-flex justify-content-center align-items-center" style={{ minHeight: 100 }}>
                  <div
                    className="spinner-border"
                    role="status"
                    style={{
                      width: '2.5rem',
                      height: '2.5rem',
                      borderWidth: '0.25em',
                      color: '#B1B7C6',
                      opacity: 0.6,
                    }}
                  ></div>
                </div>
              </div>
            )}
            {reservationsData && reservationsData.length > 0 && !loading && (
              <div className="dashboard-reservations-section">
                <div className="section-title">
                  <h3>{T("public.dashboard.my-requests")}</h3>
                </div>

                <div className="reservations-list">
                  {reservationsData.map((requestItem, idx) => {
                    console.log('0406 item', requestItem);
                    const lang = language ?? "en-US";
                    
                    const isBookableReservation = requestItem?.BookableReservation != null;
                    
                    return isBookableReservation ? (
                      (() => {
                        let _status = getStatusText(requestItem);
                        const rememberStatus = (requestItem?.BookableReservation?.rememberStatus == null && _status == "pending" && !requestItem?.BookableReservation?.confirmed?.status == true) ? false : true;
                        console.log('555 rememberStatus', rememberStatus);
                        console.log('0406 lang', lang);
                        console.log('0406 _status', _status);
                        console.log(requestItem.status);
                        let _date = '';
                        if (requestItem?.BookableReservation?.day && requestItem?.BookableReservation?.slot) {
                          _date = formatDateFromLanguage(`${requestItem.BookableReservation.day} ${requestItem.BookableReservation.slot}`, lang);
                        }
                        const _title = i18nValue(requestItem?.BookableReservation?.BookableItem, 'name', lang);
                        const _detail = qtyText(requestItem?.BookableReservation?.qty, requestItem?.BookableReservation?.qtyAdults, requestItem?.BookableReservation?.qtyChildren);

                        const containerContent = (
                          <div className="reservation-card">
                            <div className="reservation-image">
                              {requestItem?.BookableReservation?.BookableItem?.photo ? (
                                <img src={getCDNImage(requestItem?.BookableReservation?.BookableItem?.photo)} alt={_title} />
                              ) : (
                                <div className="no-image-placeholder">
                                  <img src={'/logo_57.png'} alt="No image" />
                                </div>
                              )}
                            </div>

                            <div className="reservation-content">
                              <div className="reservation-title-bar">
                                <h4 className="reservation-title">{_title}</h4>
                              </div>

                              <div className="reservation-meta">
                                <div className="meta-item">
                                  <span className="meta-label">{T("general.date")}</span>
                                  <span className="meta-value">{_date}</span>
                                </div>
                                <div className="meta-item">
                                  <span className="meta-label">{T("general.guests")}</span>
                                  <span className="meta-value">{_detail}</span>
                                </div>
                              </div>

                              {requestItem?.BookableReservation?.observations && (
                                <div className="reservation-notes">
                                  <p className="notes-title">{T("public.request.observations")}</p>
                                  <p className="notes-content">{requestItem.BookableReservation?.observations}</p>
                                </div>
                              )}
                              <div className="reservation-message">
                                {/* mensaje respecto al estado de la reserva */}
                                <p className={`message-content badge ${_status} ${!rememberStatus ? "remember-status" : ""}`}>
                                  {_status && rememberStatus ? (
                                    <span>{T(`public.reservation.status.${_status}`)}</span>
                                  ) : (
                                    <span>{T(`public.reservation.status.remember-status`)}</span>
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                        );

                        return (
                          <div key={`res-${idx}`} className="reservation-item-wrapper">
                            {requestItem.id ? (
                              <NavLink to={getUrlPath(`/public/requests/${requestItem.id}`)} className="reservation-link">
                                {containerContent}
                              </NavLink>
                            ) : (
                              containerContent
                            )}
                          </div>
                        );
                      })()
                    ) : (
                      // Card de room_service
                      (() => {
                        const _itemsQty = requestItem?.data?.items 
                          ? Object.values(requestItem.data.items).reduce((acc, qty) => acc + qty, 0) 
                          : 0;
                        

                        const containerContent = (
                          <div className="reservation-card service-card">
                            <div className="reservation-image service-icon-container">
                              <div className="service-icon-wrapper">
                                {serviceTypeIcon('beach_service', 65)}
                              </div>
                            </div>

                            <div className="reservation-content">
                              <div className="service-info">
                                <span className="service-date">
                                  {formatDateFromLanguage(requestItem?.createdAt, lang)}
                                </span>
                                <h4 className="reservation-title service-title">{T(isHotelCGBeach(hotel?.id) ? `services.type.beach_service` : `service.type.request`)}</h4>
                              </div>
                              <div className="service-items-qty">
                                <span className="items-label">{T("general.items.qty")}:</span>
                                <span className="items-value">{_itemsQty}</span>
                              </div>
                              <div className="reservation-message">
                                {/* mensaje respecto al estado de la reserva */}
                                <p className={`message-content badge label-light-${requestItem?.status}`}>
                                   <span>{T(`services.status.${requestItem?.status}`)}</span>
                                </p>
                              </div>
                            </div>
                          
                          </div>
                        );

                        return (
                          <div key={`req-${idx}`} className="reservation-item-wrapper">
                            {requestItem.id ? (
                              <NavLink to={getUrlPath(`/public/requests/${requestItem.id}`)} className="reservation-link">
                                {containerContent}
                              </NavLink>
                            ) : (
                              containerContent
                            )}
                          </div>
                        );
                      })()
                    );
                  })}
                </div>
              </div>
            )}

            {/* No Reservations State */}
            {(!reservationsData || reservationsData.length === 0) && !loading && (
              <div className="dashboard-empty-reservations">
                <div className="empty-state">
                  <span className="empty-icon">📋</span>
                  <p className="empty-text">{T("public.dashboard.no-reservations")}</p>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Screen>
  );
}

export default Dashboard;
